import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const messageHelpApi = createApi({
    reducerPath: 'messageHelpApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        setupMessageHelp: build.mutation({
            query: (data) => ({
                url: api.messageHelp.setupMessageHelp(),
                method: 'POST',
                body: data
            }),
        }),
        createMessageHelpAccount: build.mutation({
            query: (data) => ({
                url: api.messageHelp.createMessageHelpAccount(),
                method: 'POST',
                body: data
            }),
        }),
        getMessageHelpStatus: build.query({
            query: (data) => ({
                url: api.messageHelp.getMessageHelpStatus(),
                method: 'GET',
                params: data
            }),
        }),
        getActiveToken: build.query({
            query: (data) => ({
                url: api.messageHelp.getActiveToken(),
                method: 'GET',
                params: data
            }),
        }),
    })
})

export const {
    useSetupMessageHelpMutation,
    useCreateMessageHelpAccountMutation,
    useLazyGetMessageHelpStatusQuery,
    useLazyGetActiveTokenQuery
} = messageHelpApi